'use strict';

const SELECTORS = {
    formControl: 'input.js-form-control:not("#registration-form-phone"), textarea.js-form-control, select.js-select-validate',
    formPassword: '.js-form-password-control',
    formSelect: '.js-form-select:not([disabled])',
    minAgeInput: '.js-min-age-input',
	inputNotDisabled: 'input.js-form-control:not([disabled]):not([data-ignore="true"]):not("#registration-form-phone"), textarea.js-form-control:not([disabled]):not([data-ignore="true"]), select.js-select-validate:not([disabled]):not([data-ignore="true"]),select.js-select-validate:has([required]), .js-captcha-validation',
	formAccount: '.js-prefilled-form',
	formNoPrefilled: '.js-no-prefilled-form',
	currentPassword: '.js-current-password',
	panConsent        : '.js-panConsent',
	panConsentInverted: '.js-panConsentInverted',
	captcha: '.js-captcha-validation'
}

/**
 * Expected postal-code length per ISO country code.
 * Drives the country-dependent length check for the billing postal code.
 */
const POSTCODE_LENGTHS = {
    AR: 4, AT: 4, AU: 7, BE: 4, BG: 4, CA: 6, CH: 4, CL: 7, CN: 6, CR: 4,
    CY: 4, CZ: 6, DE: 5, DK: 4, DZ: 5, EE: 5, ES: 5, FI: 5, FO: 3, FR: 5,
    GR: 5, HR: 5, HU: 4, ID: 5, IL: 7, IN: 6, IR: 5, IS: 3, IT: 5, JP: 7,
    KP: 7, KR: 7, KW: 5, KZ: 6, LI: 4, LS: 3, LT: 8, LU: 4, LV: 7, MC: 5,
    MT: 7, MX: 5, MY: 5, NL: 7, NO: 4, NP: 6, NZ: 4, PH: 4, PL: 6, PT: 6,
    RO: 6, RU: 6, SA: 5, SE: 6, SG: 6, SI: 4, SK: 6, TD: 5, TH: 5, TN: 4,
    TR: 5, TW: 3, UA: 5, US: 10, VE: 4, VN: 5, ZA: 4
};

/**
 * Sync the postal-code length constraints (minlength/maxlength) with the selected
 * country. Setting min === max turns the existing generic range check in
 * validateField() into an exact-length check, so no postcode-specific branch is
 * needed. Countries without a defined length get no constraints, which keeps the
 * range check inert for them (parseFloat(undefined) === NaN => comparisons are false).
 * @param {JQuery} $zip - The postal-code input
 * @param {string} country - ISO country code (e.g. 'DE')
 * @returns {void}
 */
function applyPostcodeConstraints($zip, country) {
	if (!$zip || !$zip.length) {
		return;
	}
	var len = POSTCODE_LENGTHS[country];
	if (len !== undefined) {
		$zip.attr('minlength', len).attr('maxlength', len);
	} else {
		// No defined length for this country -> range check stays inert.
		$zip.removeAttr('minlength').removeAttr('maxlength');
	}

	// Append the expected length to the range-error message, e.g.
	// "Bitte gib eine gültige Postleitzahl ein (5 Zeichen)".
	// Capture the original text once so repeated country switches don't stack the suffix.
	var baseRangeError = $zip.data('range-error-base');
	if (baseRangeError === undefined) {
		baseRangeError = $zip.attr('data-range-error') || '';
		$zip.data('range-error-base', baseRangeError);
	}
	var rangeError = (len !== undefined)
		? baseRangeError + ' (' + len + ' Zeichen)'
		: baseRangeError;
	// Keep the attribute and jQuery's .data() cache in sync, because validateField()
	// reads the message via $(field).data('range-error') and that cache is otherwise
	// independent of later attribute changes.
	$zip.attr('data-range-error', rangeError).data('range-error', rangeError);
}

/**
 * Keep the postal-code constraints in sync with the frontend-only billing country
 * switch and re-validate the field so the correct message is shown
 * (data-missing-error when empty, data-range-error when the length is wrong).
 */
$('body').on('change', '[name="dwfrm_billing_addressFields_country"], [name="dwfrm_profileAddress_billingAddress_country"]', function () {
	var $zip = $(this).closest('form').find('[name="dwfrm_billing_addressFields_postalCode"], [name="dwfrm_profileAddress_billingAddress_postalCode"]');
	if (!$zip.length) {
		return;
	}
	applyPostcodeConstraints($zip, $(this).val());
	validateField($zip.get(0));
});

// Initialise the constraints for the country preselected on page load (no validation yet).
$(function () {
	$('[name="dwfrm_billing_addressFields_postalCode"], [name="dwfrm_profileAddress_billingAddress_postalCode"]').each(function () {
		var $zip = $(this);
		var country = $zip.closest('form').find('[name="dwfrm_billing_addressFields_country"], [name="dwfrm_profileAddress_billingAddress_country"]').val();
		applyPostcodeConstraints($zip, country);
	});
});

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */

function clearFormErrors(form) {
	$(form).find('.form-control.cc-invalid').removeClass('cc-invalid');
	$(form).find('.invalid-feedback').removeClass('cc-message--visible').text('');
	$(form).find('.cc-form__wrap--error').removeClass('cc-form__wrap--error');
}

var validatedFieldsPerForm = {};

$(SELECTORS.formAccount).each(function() {
	var form = $(this);
    var formName = form.attr('name');
	var submitButton = form.find('button[type="submit"]');

	var validatedFields = validatedFieldsPerForm[formName] || {};
	form.find(SELECTORS.inputNotDisabled).each(function(index,val) {
        const field = $(val);
        const fieldName = field.attr('name');

        let fieldValue = '';

        if (field.attr('type') === 'checkbox') {
            fieldValue = (field.is(':checked') || '');
        } else {
            fieldValue = (field.val() || '').trim();
        }

		if (fieldName === undefined) {
			return;
		}
		// Track only required fields; optional fields must never block the submit state.
		if (!field.prop('required')) {
			return;
		}
        validatedFields[fieldName] = fieldValue !== '';
		
    });
    
    validatedFieldsPerForm[formName] = validatedFields;
	
	var allFieldsValid = Object.values(validatedFieldsPerForm[formName]).every(value => value === true);
	if (allFieldsValid && !form.hasClass('cc-novalidate')) {
		submitButton.removeClass('cc-disabled').prop('disabled', false);
	}
});

$('body').on('blur change input show.bs.modal', SELECTORS.formControl, function(e) {
	
    // Workaround for Edge Problem with bootstrap select boxes, omit blur (focusout) event when is not visible, it causes validation errors, see NOA-4814
    if (e.type === 'focusout' && $(this).is('select') && !$(e.target).is(':visible')) {
		return;
    }
	var form = $(this).closest('form');
	var validatedFields = validatedFieldsPerForm[form.attr('name')] || {};
	validateField(this, validatedFields);
});

$('body').on('formValidation:revalidate', function(e, form) {
    // required if triggered via jQuery or vanilla JavaScript
    var detail = e.originalEvent?.detail ?? '';
    var formClass = form ?? detail?.formClass;
    var nameForm = formClass ? document.querySelector(formClass).getAttribute('name') : detail?.formName;
    form = formClass ? formClass : document.querySelector(`form[name="${nameForm}"]`).className;
    const selector = $(SELECTORS.formAccount).length ? $(SELECTORS.formAccount) : $(SELECTORS.formNoPrefilled);

	var captchaFriendlyState = null;

	clearFormErrors(form);

	// save captcha state
	for (const key in validatedFieldsPerForm[nameForm]) {
		if (key === 'captchaFriendly') {
			captchaFriendlyState = validatedFieldsPerForm[nameForm][key];
		}
	}

	// reset form validaton
	validatedFieldsPerForm = {};

	selector.each(function() {
		var form = $(this);
		var formName = form.attr('name');
		var submitButton = form.find('button[type="submit"]');
		var validatedFields = validatedFieldsPerForm[formName] || {};

		form.find(SELECTORS.inputNotDisabled).each(function(index,val) {
			const field = $(val);
			const fieldName = field.attr('name');
			const fieldValue = (field.val() || '').trim();

			if (fieldName === undefined) {
				return;
			}

			validatedFields[fieldName] = fieldValue !== '';
		});

		validatedFieldsPerForm[formName] = validatedFields;

		// reset captcha state
		if (document.querySelector('.js-contact-captcha')) {
			validatedFieldsPerForm[formName]['captchaFriendly'] = captchaFriendlyState;
		}

		var allFieldsValid = Object.values(validatedFieldsPerForm[formName]).every(value => value === true);
		if (!allFieldsValid && !form.hasClass('cc-novalidate')) {
			submitButton.addClass('cc-disabled').prop('disabled', true);
		} else {
			submitButton.removeClass('cc-disabled').prop('disabled', false);
		}
	});
});

/**
 * Clear form validation for a specific form
 */
$('body').on('formValidation:clear', function(e, name) {
	if (name) {
		validatedFieldsPerForm[name] = {};
	} else {
		validatedFieldsPerForm = {};
	}
});

/**
 * Resets form validation for a specific form
 */
$('body').on('formValidation:reset', function(e, name) {
	if (name) {
		for (let field in validatedFieldsPerForm[name]) {
			validatedFieldsPerForm[name][field] = false;
		}
	}
});

/**
 * Rescan form fields against current required-state in DOM.
 * Call this after dynamically toggling required on fields (e.g. DHL location).
 * - Adds newly-required fields to the map (false if empty, true if filled)
 * - Removes fields that are no longer required
 */
$('body').on('formValidation:rescan', function(e, name) {
	var $forms = name ? $('form[name="' + name + '"]') : $(SELECTORS.formAccount);
	$forms.each(function() {
		var form = $(this);
		var formName = form.attr('name');
		if (!formName) return;

		var validatedFields = validatedFieldsPerForm[formName] || {};
		var seenRequiredNames = {};

		form.find(SELECTORS.inputNotDisabled).each(function() {
			var field = $(this);
			var fieldName = field.attr('name');
			if (fieldName === undefined) return;
			if (!field.prop('required')) return;

			seenRequiredNames[fieldName] = true;
			if (!(fieldName in validatedFields)) {
				validatedFields[fieldName] = (field.val() || '').trim() !== '';
			}
		});

		Object.keys(validatedFields).forEach(function(key) {
			if (!seenRequiredNames[key]) {
				delete validatedFields[key];
			}
		});

		validatedFieldsPerForm[formName] = validatedFields;
	});
});

/**
 * Trigger when inverted pan consent is changed ()
 * set the non inverted consent field to the the proper value (inverted)
 */
$('body').on('change', SELECTORS.panConsentInverted, function (e) {
	
	const isPanConsentInvertedChecked = $(this).is(':checked');
	const panConsent = $(SELECTORS.panConsent);
	panConsent.val(!isPanConsentInvertedChecked);
	
});

/**
 * Check the validation of the shipping adress form and activate or deactivate the next button.
 */
$('body').on('shippingAdress:change', function (e) {
	var form = $('.js-shipping-form').closest('form');
	var formName = form.attr('name');
	var submitButton = form.find('button[type="submit"]');

	var allFieldsValid = Object.values(validatedFieldsPerForm[formName]).every(value => value === true);
	if (!allFieldsValid && !form.hasClass('cc-novalidate')) {
		submitButton.addClass('cc-disabled').prop('disabled', true);
	} else {
		submitButton.removeClass('cc-disabled').prop('disabled', false);
	}
});
 
/**
 * Helper: Validate a single field based on type and value during payment form interaction.
 * Handles special cases like birthday validation.
 * @param {string} fieldName - The name of the field
 * @param {string} fieldValue - The trimmed value of the field
 * @param {JQuery} field - The field jQuery object
 * @returns {boolean} - True if field is valid, false otherwise
 */
function isFieldValidInPayment(fieldName, fieldValue, field) {
	// Field cannot be empty if required
	if (fieldValue === '') {
		return false;
	}

	// Special validation for birthday fields
	if (fieldName === 'dwfrm_billing_birthday') {
		var minVal = field.attr('min');
		var birthDateValid = validateBirthDate(fieldValue, minVal);
		return birthDateValid === true;
	}

	// Add other field-type validations here as needed
	
	return true;
}

/**
 * Helper: Update submit button disabled state based on validation status of all fields.
 * @param {JQuery} submitButton - The submit button element
 * @param {JQuery} form - The form element
 * @param {Object} validatedFields - Object tracking validation status per field
 * @returns {void}
 */
function updateSubmitButtonState(submitButton, form, validatedFields) {
	var allFieldsValid = Object.values(validatedFields).every(function(value) {
		return value === true;
	});
	
	if (!allFieldsValid && !form.hasClass('cc-novalidate')) {
		submitButton.addClass('cc-disabled').prop('disabled', true);
	} else {
		submitButton.removeClass('cc-disabled').prop('disabled', false);
	}
}

/**
 * Trigger when payment method is changed:
 * Reset ValidatedFieldsPerForm['dwfrm_payment'] when the payment method is changed to validate only the active fieldset.
 * Activate, deactivate Next button for payment form
 */
$('body').on('payment:change', function() {
	validatedFieldsPerForm['dwfrm_payment'] = {}; // Reset the validatedFieldsPerForm so that not the entire payment form is validated but only the active fieldset.

	var form = $('.paymentMethod').closest('form');
	var formName = form.attr('name');
	var submitButton = form.find('button[type="submit"]');
	var validatedFields = validatedFieldsPerForm[formName] || {};

	$('.paymentMethod').each(function () {
		var $inputs = $(this).find('input[type="radio"]');

		if ($inputs.is(':checked')) {
			const $activeFieldset = $inputs.closest('fieldset');

			$activeFieldset.each(function() {
				
				$activeFieldset.find(SELECTORS.inputNotDisabled).each(function(index,val) {
					var field = $(val);
					var fieldName = field.attr('name');
					var fieldValue = field.val() ? field.val().trim() : '';
					
					if (fieldName === undefined) {
						return;
					}

					// Determine if field is valid based on its type and value
					validatedFields[fieldName] = isFieldValidInPayment(fieldName, fieldValue, field);
				});

				validatedFieldsPerForm[formName] = validatedFields;

				// Update submit button state based on all validated fields
				updateSubmitButtonState(submitButton, form, validatedFieldsPerForm[formName]);
			});
		}
	});
});

/**
 * Remove error status from input field
 * @param {JQuery} divParent - The parent div of the input field
 * @param {JQuery} feedbackElement - The feedback element to be shown with the error message
 */
function removeErrorStatus (divParent, feedbackElement) {
	feedbackElement.removeClass('cc-message--visible');
	if (feedbackElement.next(".cc-double-rows-message").is('div:not(.d-none)')) {
	} else {
		feedbackElement.html('&nbsp;');
	}
	divParent.removeClass('cc-form__wrap--error');
	divParent.find('.cc-icon--success').show();
	divParent.find('.cc-icon--warning').hide();
	divParent.find('.cc-icon--error').hide();
}

/**
 * Add error status to input field
 * @param {JQuery} divParent - The parent div of the input field
 * @param {JQuery} feedbackElement - The feedback element to be hidden with the error message
 */
function addErrorStatus (divParent, feedbackElement) {
	feedbackElement.addClass('cc-message--visible');
	divParent.addClass('cc-form__wrap--error');
	divParent.find('.cc-icon--success').hide();
	divParent.find('.cc-icon--warning').hide();
	divParent.find('.cc-icon--error').show();
}

/**
 * Checks if the address input contains forbidden DHL Packstation patterns.
 * Updates the global validatedFieldsPerForm state and toggles the submit button.
 * TODO: After adding the pickup navigator, delete this special case and clean up all isForbiddenDHLPattern() invocations.
 * * @param {HTMLElement} field - The native DOM element (passed from jQuery .each or event)
 * @returns {boolean} - Returns true if a forbidden pattern is found (validation fails).
 */
function isForbiddenDHLLockerPattern(field) {
    
	const $field = $(field);
    const $form = $field.closest('form');

	if ($form.attr('data-address-mode') === 'dhl-location') {
		return false;
    }

    const formName = $form.attr('name');
    const $wrap = $field.closest('.cc-form__wrap');
    const $feedback = $wrap.find('.invalid-feedback');
    const $submitBtn = $form.find('button[type="submit"]');
    
    const fieldValue = ($field.val() || '').trim();
    const fieldName = $field.attr('name');
    const fieldId = field.id;

    const FIELDS_TO_BE_CHECKED = new Set([
        'address1', 'address2', 'address3', 'firstName', 'lastName', 'streetNumber', 'nameCo', 'city',
        'shippingAddressOnedefault', 'shippingFirstNamedefault', 'shippingAddressAddress3default', 'shippingAddressNameCodefault', 'shippingLastNamedefault', 'shippingAddressCitydefault', 'shippingStreetNumberdefault', 
		'billingFirstName', 'billingLastName', 'billingAddressOne', 'billingStreetNumber', 'billingAddressCity', 'billingAddressAddress3default', 'billingAddressNameCo', 
		'pickup-shipping-FirstNamedefault', 'pickup-shipping-LastNamedefault'
    ]);

    // Simplified regex: Matches "packstation", "pacstation", "pakstadion", etc.
    const packstationRegex = /pa[kc]{1,2}sta[td]ion/i;
    const errorMessage = $('[data-dhl-locker-message]').data('dhl-locker-message');

    const isTextField = $field.is('input[type="text"], textarea, input:not([type])');
    const shouldValidate = FIELDS_TO_BE_CHECKED.has(fieldId) && isTextField;

    // If we shouldn't validate this field, or it's empty, we clear errors and update the button.
    if (!shouldValidate || fieldValue === '') {
        $feedback.text(''); 
        
        if (validatedFieldsPerForm[formName]) {
            validatedFieldsPerForm[formName][fieldName] = true;
            updateSubmitButtonState($submitBtn, $form, validatedFieldsPerForm[formName]);
        }
        return false;
    }

    const hasForbiddenPattern = packstationRegex.test(fieldValue);

    if (hasForbiddenPattern) {
        if ($feedback.length === 0) {
            $field.after(`<div class="invalid-feedback">${errorMessage}</div>`);
        } else {
            addErrorStatus($wrap, $feedback);
            $feedback.text(errorMessage);
        }
    } else {
        $feedback.text('');
    }

    if (validatedFieldsPerForm[formName]) {
        validatedFieldsPerForm[formName][fieldName] = !hasForbiddenPattern;
        updateSubmitButtonState($submitBtn, $form, validatedFieldsPerForm[formName]);
    }

    return hasForbiddenPattern;
}

function validateField(field, validatedFields) {
	var isValid = true;
	var form = $(field).closest('form');
	var formName = form.attr('name');
	var fieldName = $(field).attr('name');
	var errorMessage = $(field).data('missing-error');
	var rangeErrorMessage = $(field).data('range-error');
	var patternErrorMessage = $(field).data('pattern-mismatch');
	var patternErrorAddress = $(field).attr('pattern');
	var patternErrorCap = $(field).data('cap');
	var capErrorMessage = $(field).closest('.js-form-wrap').find('.invalid-feedback').data('errormsg');
	var feedbackElement = $(field).closest('.cc-form__wrap').find('.invalid-feedback');
	var divParent = $(field).closest('.cc-form__wrap');
	var iconError = $('.js-icon--warning.d-none');
	var submitButton = form.find('button[type="submit"]');
    let fieldValue = '';

    if ($(field).attr('type') === 'checkbox') {
        fieldValue = ($(field).is(':checked') || '');
    } else {
        fieldValue = ($(field).val() || '').trim();
    }

	// TODO: Special case for dhl locker pattern, to be removed after adding the pickup navigator, remove the call of isForbiddenDHLPattern()
	if (isForbiddenDHLLockerPattern(field)) {
		return false;
	} else if (!$(field).prop('required') ) {
		if (validatedFieldsPerForm[formName] && fieldName !== undefined && fieldName in validatedFieldsPerForm[formName]) {
			delete validatedFieldsPerForm[formName][fieldName];
		}
		feedbackElement.text('');
		removeErrorStatus(divParent, feedbackElement);
		return;
	} else if (fieldValue === '' && $(field).prop('required')) {

		if (feedbackElement.length === 0) {
			$(field).after('<div class="invalid-feedback">' + errorMessage + '</div>');
		} else {
			addErrorStatus(divParent, feedbackElement);
			feedbackElement.addClass('cc-message--visible').text(errorMessage);
		}
		isValid = false;
	} else {
		feedbackElement.text('');
	}

	if (rangeErrorMessage && fieldValue !== '' && !$(field).data('password')) {
		var min = parseFloat($(field).attr('minlength'));
		var max = parseFloat($(field).attr('maxlength'));
		var value = parseFloat(fieldValue.length);
		if (isNaN(value) || value < min || value > max) {
			if (feedbackElement.length === 0) {
				$(field).after('<div class="invalid-feedback">' + rangeErrorMessage + '</div>');
			} else {
				addErrorStatus(divParent, feedbackElement);
				feedbackElement.addClass('cc-message--visible').text(rangeErrorMessage);
			}
			isValid = false;
		}
	}

	if ($(field).data('confirm-password')) {
		var $form = $(field).closest('form');
		var passwordField = $form.find(SELECTORS.formPassword);
		var confirmPasswordValue = fieldValue;
		var passwordValue = passwordField.val().trim();
		var confirmFeedbackElement = $(field).closest('.js-form-wrap').find('.invalid-feedback');
		if (confirmPasswordValue !== passwordValue) {
			var confirmErrorMessage = $(confirmFeedbackElement).data('errormsg');
			if (confirmFeedbackElement.length === 0) {
				$(field).after('<div class="invalid-feedback">' + confirmErrorMessage + '</div>');
			} else {
				addErrorStatus(divParent, confirmFeedbackElement);
				confirmFeedbackElement.addClass('cc-message--visible').text(confirmErrorMessage);
			}
			isValid = false;
		}
	}
	let id = $(field).attr('id');
	if ($(field).data('password') && (id !== "login-form-password" && id !== "currentPassword")) {
		var errorMessage = '';
		var samePasswordErrorMessage = $(field).data('same-password-error');
		var feedbackElement = divParent.find('.invalid-feedback');

		var confirmFieldElement = $('[data-confirm-password]');
		var confirmFieldName = confirmFieldElement.attr('name');
		var confirmField = confirmFieldElement.val();
		var confirmFieldFeedback = confirmFieldElement.closest('.js-form-wrap').find('.invalid-feedback');
		var confirmedErrorMessage = confirmFieldFeedback.data('errormsg');
		var divParentConfirmField = confirmFieldElement.closest('.js-form-wrap');
		if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/.test(fieldValue)) {
			errorMessage = $(feedbackElement).data('errormsg');
			isValid = false;
		}
	
		var currentPasswordWrapper = $(form).find(SELECTORS.currentPassword);
		if (currentPasswordWrapper.length > 0) {
			var currentPasswordField = currentPasswordWrapper.find(SELECTORS.formControl);
			var currentPasswordValue = currentPasswordField.val().trim();
			if (fieldValue === currentPasswordValue) {
				errorMessage = samePasswordErrorMessage;
				isValid = false;
			}
		}

		if (errorMessage) {
			if (feedbackElement.length === 0) {
				$(field).after('<div class="invalid-feedback cc-message cc-message--visible">' + errorMessage + '</div>');
			} else {
				addErrorStatus(divParent, feedbackElement);
				feedbackElement.addClass('cc-message--visible').text(errorMessage);
				feedbackElement.removeClass('d-none');
			}
			const passwordMessage = divParent.find('.cc-password-message');
			passwordMessage.addClass('d-none');
		} else {
			feedbackElement.text('');
			removeErrorStatus(divParent, feedbackElement);
		}

		if (confirmField != undefined) {
			if (fieldValue == confirmField && isValid  ) {
				confirmFieldFeedback.text('');
				removeErrorStatus(divParentConfirmField, confirmFieldFeedback);
				validatedFieldsPerForm[formName][confirmFieldName] = true;
			} 
			if (fieldValue != confirmField && confirmField.length != '') {
				confirmFieldFeedback.text(confirmedErrorMessage);
				addErrorStatus(divParentConfirmField, confirmFieldFeedback);
				$(confirmFieldElement).after(iconError.clone().removeClass('d-none'));
				validatedFieldsPerForm[formName][confirmFieldName] = false;
			}
		}
	}

	if (patternErrorMessage && fieldValue !== '') {
		var pattern = new RegExp($(field).attr('pattern'));
		if (!pattern.test(fieldValue)) {
			if (feedbackElement.length === 0) {
				$(field).after('<div class="invalid-feedback">' + patternErrorMessage + '</div>');
			} else {
				addErrorStatus(divParent, feedbackElement);
				feedbackElement.text(patternErrorMessage);
			}
			isValid = false;
		}
	}

	if ($(field).data('capitalize-first')) {
		var value = $(field).val();
        if (value) {
			value = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
			$(field).val(value);
        }
    }

	if (fieldName === 'dwfrm_clubMembership_customer_birthday' || 
        fieldName === 'dwfrm_profile_customer_birthday' || 
        fieldName === 'dwfrm_profileAddress_customer_birthday' || 
        fieldName === 'dwfrm_billing_birthday' || 
        fieldName === 'dwfrm_newPasswords_birthday'
    ) {
		var minVal = $(field).attr('min');
		var birthDateValid = validateBirthDate(fieldValue,minVal);
		if (birthDateValid === 'before') {
			var birthDateErrorMessage = $(field).data('error-age');
		} else if (birthDateValid === 'after') {
			var birthDateErrorMessage = $(field).data('min-age');
		}
	
		if (birthDateErrorMessage) {
			if (feedbackElement.length === 0) {
				$(field).after('<div class="invalid-feedback">' + birthDateErrorMessage + '</div>');
			} else {
				addErrorStatus(divParent, feedbackElement);
				feedbackElement.text(birthDateErrorMessage);
				feedbackElement.removeClass('d-none');
			}
			const ageMessage = divParent.find('.cc-age-message');
			const ageInput = divParent.find('.cc-form__input');
			ageMessage.addClass('d-none');
			ageInput.addClass('cc-age-input-valid');
			isValid = false;
		}
	}

	if ($(field).hasClass('cc-select')) {
		var selectedValue = $(field).val();
		var selectError = $(field).data('missing-error');
		var fieldName = $(field).attr('name');
		if (selectedValue !== null && selectedValue !== '' && selectedValue !== undefined) {
			feedbackElement.text('');
			removeErrorStatus(divParent, feedbackElement);
			isValid = true;
		} else {
			addErrorStatus(divParent, feedbackElement);
			feedbackElement.text(selectError);
			isValid = false;
		}
	}

	if ($(field).data('address')) {
	
		var regex = new RegExp(patternErrorAddress);
	
		if (!regex.test(fieldValue)) {
			addErrorStatus(divParent, feedbackElement);
			isValid = false;
		}
	}

	if ($(field).data('cap')) {
		var regex = new RegExp(patternErrorCap);
	
		if (!regex.test(fieldValue)) {
			addErrorStatus(divParent, feedbackElement);
			feedbackElement.text(capErrorMessage);
			isValid = false;
		}
	}
	
	if (!validatedFieldsPerForm[formName]) {
		validatedFieldsPerForm[formName] = {};
	}

	if (fieldName !== undefined) {
		validatedFieldsPerForm[formName][fieldName] = isValid;
	}
	
	var validFieldsCount = Object.values(validatedFieldsPerForm[formName]).filter(function(item) {
		return item === true;
	});

	/**
	 * Checks the fields from the entire form are used or only from the fieldset
	 * @returns {boolean}
	 */
	function isValidFormOrFieldset() {
		return validFieldsCount.length >= Object.keys(validatedFieldsPerForm[formName] || {}).length;
	}

	if (isValidFormOrFieldset()) {
		submitButton.removeClass('cc-disabled').prop('disabled', false);
	} else if (!form.hasClass('cc-novalidate')) {
		submitButton.addClass('cc-disabled').prop('disabled', true);
	}
	if (isValid) {
		removeErrorStatus(divParent, feedbackElement);
	}

	if (!isValid) {
		if (divParent.find('.cc-icon--warning').length == 0) {
			$(field).after(iconError.clone().removeClass('d-none'));
		}
	}
	return isValid;

}

function validateBirthDate(birthDate,minVal) {

	var date = $(SELECTORS.minAgeInput).attr('minlength');
	var minDate = new Date(minVal);
    var maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() - date);
    var inputDate = new Date(birthDate);

    if (inputDate < minDate) {
        return "before";
    }

    if (inputDate > maxDate) {
        return "after";
    }

    return true;
}

function validateForm(form) {
	var isValid = true;

	$(form).find(SELECTORS.formControl).each(function() {
		if (!validateField(this)) {
			isValid = false;
		}
	});

	return isValid;
}


const formValidation = function(formElement, payload, invalidFeed = '', containerInput = '') {

	// clear form validation first
	clearFormErrors(formElement);
	$('.alert', formElement).remove();
	var isFormValid = validateForm(formElement);


	if (!isFormValid) {
		return; // if form is valid, don't send it and show error
	}

	if (typeof payload === 'object' && payload.fields) {
		Object.keys(payload.fields).forEach(function(key) {
			if (payload.fields[key]) {
				var feedbackElement = $(formElement).find('[name="' + key + '"]')
					.parent()
					.children('.invalid-feedback');

				if (feedbackElement.length > 0) {
					if (Array.isArray(payload[key])) {
						feedbackElement.html(payload.fields[key].join('<br/>'));
					} else {
						feedbackElement.html(payload.fields[key]);
					}
					feedbackElement.siblings('.form-control').addClass('is-invalid');
				}
			}
		});
	}
	if (payload && payload.error) {
		var form = $(formElement).prop('tagName') === 'FORM' ? $(formElement) : $(formElement).parents('form').find('.invalid-feedback');

		if (invalidFeed != '') {
			addErrorStatus(containerInput, invalidFeed);
			invalidFeed.append(payload.error.join('<br/>'));
		} else {
			form.append('<div class="alert alert-danger" role="alert">' +
				payload.error.join('<br/>') + '</div>');
		}
	}
};

module.exports = formValidation;
module.exports.SELECTORS = SELECTORS;
module.exports.POSTCODE_LENGTHS = POSTCODE_LENGTHS;

function solveCaptcha(solution) {
	const captchaSolution = document.querySelector('input[type="hidden"][value="' + solution +'"]');
	let captcha = $(captchaSolution).closest(SELECTORS.captcha);
	let captchaName = captcha.attr('name');
	let form = $(captchaSolution).closest('form');
	let formName = form.attr('name');
	let enableSubmit = true;
	var submitButton = form.find('button[type="submit"]');
	validatedFieldsPerForm[formName][captchaName] = true;

	for (var field in validatedFieldsPerForm[formName]) {
		if (!validatedFieldsPerForm[formName][field]) {
			enableSubmit = false;
		}
	}

	if (enableSubmit) {
		submitButton.removeClass('cc-disabled').prop('disabled', false);
	}
}

window.solveCaptcha = solveCaptcha;